<template>
  <div style="padding: 10px;">
  <!-- <a-modal 
    :title="title"
    :visible="visible.raw"
    @ok="ok" 
    @cancel="cancel"
    :bodyStyle="modalBodyStyle"
    :forceRender="true"
    :footer="false"
    destroyOnClose
    width="1100px"> -->
    <div style="height: 30px;border-bottom: 1px solid #eee;margin-bottom: 10px;">
      <h3 style="font-size: 14px;font-weight:normal;display: inline-block;">
        {{overseasFlag == '1' && rawSelect ? (rawSelect.aliasName || rawSelect.rawName) : rawSelect.rawName}}
      </h3>
      <a-icon type="close" @click="closeBox" style="float: right;font-size: 20px;" />
    </div>
    <a-row type="flex" align="middle" justify="space-between" class="header">
      <a-space style="margin-bottom: 5px;">
        <a-input-search :allowClear="true" v-model="keyword" size="small" placeholder="输入名称/代码" @change="searchChange" style="width: 150px" @search="onSearch" />
        <base-list-select style="width:150px" category="nutritiontarget" placeholder="选择类型" @change="typeChange" @select="selectItem" :value="types" />
        <a-select
          @change="nutritionChange"
          style="width:150px"
          placeholder="选择养分表"
          v-model="filterData.linkId"
        >
          <a-select-option v-for="(item,index) in nutritionList" :title="item.name" :key="index" :value="item.id">
            {{item.name}}
          </a-select-option>
        </a-select>
      </a-space>
      <a-space>
        <a-select :disabled="rawSelect.isFucCal != 1" style="width:150px" placeholder="选择方程" v-model="equationId" @change="selectEquation">
          <a-select-option v-for="(item,index) in equation" :key="index" :value="item.id">
            {{item.name}}
          </a-select-option>
        </a-select>
        <a-button :disabled="rawSelect.isFucCal != 1" :loading="calculateLoading" size="small" type="primary" @click="calculate">计算</a-button>
      </a-space>
      </a-row>
      <a-table
        :columns="columns"
        :data-source="list.records"
        :row-key="record => record.code"
        :pagination="false"
        :loading="listLoading"
        :scroll="{ x: 800, y: height - 50 }"
        @change="listChange"
      >
        <a-tooltip slot="name" slot-scope="text">
          <template slot="title">
            {{text}}
          </template>
          <span class="nameStyle">{{text}}</span>
        </a-tooltip>
        <span slot="customTitle"><a-icon @click="fixedCol"  type="pushpin" :theme="filled ? 'filled' : 'outlined'" /> 指标名称</span>
        <template
          v-for="col in ['nutritionValue']" :slot="col"
          slot-scope="text, record">
            <span :key="col" v-if="record.isAutoCal== 1">{{text || text === 0 ? text.toFixed(4) : ''}}</span>
            <cell-editor v-else :len="4" :background="true" :item="record" :key="col" :name="col" @blur="target => itemChange(target,col)" :text="text" :actions="target => update(target,record.nutritionId)" :precision='4'/>
          </template>
        <template slot="analysisVal" slot-scope="text,record">
          {{ text === '' || text === null ? text : Number(text).toFixed(record.unit === 'MJ' || record.unit === 'Kcal' ? 4 : 4)}}
        </template>
        <template slot="val" slot-scope="text">
          {{ text === '' || text === null ? text : Number(text).toFixed(4)}}
        </template>
        <template slot="content" slot-scope="text,record">
          {{getContent(record)}}
        </template>
        <template slot="contentPercentage" slot-scope="text,record">
          {{getContent(record) ? div(getContent(record),allVal).toFixed(4) : null}}
        </template>
    </a-table>
  <!-- </a-modal> -->
  </div>
</template>

<script>
import { nhfMixins } from '../../untils'
import CellEditor from '../editor/CellEditor.vue'
import BaseListSelect from '../select/BaseListSelect.vue'
export default {
  components: { 
    BaseListSelect, 
    CellEditor },
  mixins:[nhfMixins],
  data(){
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      cacheData:[],
      resultLoading:false,
      columns:[
        {
          dataIndex:'name',
          // title:'指标名称',
          width: 160,
          slots: { title: 'customTitle' },
          scopedSlots: {customRender: 'name'},
          // fixed: 'left'
        },
        {
          dataIndex:'code',
          title:'代码',
          width:100
        },
        {
          dataIndex:'typeName',
          title:'类型',
          width:220
        },
        {
          dataIndex:'nutritionValue',
          scopedSlots: {customRender: 'nutritionValue'},
          title:'数值',
          width:150,         
          sorter: (a, b) => a.nutritionValue - b.nutritionValue,
          sortDirections: ['descend', 'ascend'],
          align:'center'
        },
        {
          dataIndex:'nutritionAnalysisVal',
          scopedSlots: {customRender: 'analysisVal'},
          title:'营养分析',
          sorter: (a, b) => a.nutritionAnalysisVal - b.nutritionAnalysisVal,
          sortDirections: ['descend', 'ascend'],
          width:150,
          align:'center'
        },
        {
          // dataIndex:'content',
          scopedSlots: {customRender: 'content'},
          width: 150,
          title:'养分',
          sorter: (a, b) => this.getContent(a) - this.getContent(b),
          sortDirections: ['descend', 'ascend'],
        }
      ],
      list:{
        records:[]
      },
      equation:{
        records:[]
      },
      batStatus:false,
      keyword:'',
      equationId:null,
      types:[],
      listLoading:false,
      calculateLoading:false,
      nutritionId:null,
      calculateResult:[],
      isContain:true,
      filterData:{},
      hidden:false,
      filled: false
    }
  },
  computed:{
    eidtorText(){
      return this.batStatus ? '取消编辑' : '批量编辑'
    },
    title(){
      return this.rawSelect ? this.rawSelect.rawName : ''
    },
    allVal(){
      return this.list.records.reduce((val, item) => val + (item.nutritionAnalysisVal === null || item.nutritionAnalysisVal === '' ? 0 : item.nutritionAnalysisVal) , 0)
    },
  },
  mounted(){
    this.getList()
    this.getEquationList()
    this.filterData.linkId = this.detail.linkId
  },
  watch:{
    rawSelect(val){
      this.types = []
      this.filterData.typeId = undefined
      this.filterData.linkId = this.detail.linkId
      if(val && val.rawId) {
        this.isContain = true
        this.$nextTick(()=>{
          this.list.records = []
          this.getList()
        })
      }
    },
    visible(val){
      if(val.raw){
        this.getList()
      }
    },
    

  },
  methods:{
    changeColumns(){
      let columns = [...this.columns]
      if(this.filled){
        columns[0].fixed = 'left'
      }else{
        delete columns[0].fixed
      }
      this.columns = columns
    },
    fixedCol(e){
      this.filled = !this.filled
      this.changeColumns()
      e = e || window.event;  
      if(e.stopPropagation) { //W3C阻止冒泡方法  
          e.stopPropagation();  
      } else {  
          e.cancelBubble = true; //IE阻止冒泡方法  
      }
    },
    closeBox(){
      this.$emit("refresh")
      this.setState({calculaVisible: false})
    },
    getContent(val){
      if(!this.rawSelect) return
      const {percentage} = this.rawSelect
      return (percentage === '' || percentage === null || !val || val.nutritionAnalysisVal === '' || val.nutritionAnalysisVal === null) ? null : this.div(this.mul(val ? val.nutritionAnalysisVal : 0, percentage),100).toFixed(4)
    },

    selectEquation(val){
      this.equationId = val
    },

    toggleContain(isContain, list = false){
      this.$nextTick(()=>{
        this.batStatus = false
        let arrs = list || this.cacheData
        let arr = JSON.parse(JSON.stringify(arrs))
        this.list.records = isContain ? arr : arr.filter(i => i.isContain === "1")
      })
    },

    selectItem(val){
      if(val === undefined) {
        this.toggleContain(this.isContain,this.cacheData)
      }
    },

    async setResult(listChange){
      if(listChange.length > 0){
        this.filterData = {linkId: this.detail.linkId}
        this.types = []
        let factoryStaffNutritionRawList = []
        // const featherList = this.list.records.map(i=>{
        //   const {rawId} = i
        //   let filterArray =  listChange.filter(item=>i.code === item.code)
        //   return {...i,...filterArray[0],rawId}
        // })
        // featherList.forEach(i=>{
        //     const { isContain,nutritionId,culationValue,rawId,staffId,id,factoryId,isBelongRaw } = i
        //     if(i.culationValue !== i.nutritionValue){
        //       factoryStaffNutritionRawList.push({isContain,factoryId,nutritionId,nutritionValue:culationValue,isBelongRaw,formulaId:this.formulaId,rawId,id,staffId })
        //     }
        // })
        listChange.forEach(el => {
          const { isContain,nutritionId,culationValue,nutritionValue,rawId,id } = el
          if(culationValue !== nutritionValue){
            factoryStaffNutritionRawList.push({
              nutritionId,rawId,id,isContain,
              nutritionValue: culationValue,
              isBelongRaw: !id ? '0' : '1',
              factoryId: window.localStorage.getItem('factoryId'),
              staffId: window.localStorage.getItem('staffId'),
            })
          }
        })
        if(factoryStaffNutritionRawList.length){
          this.listLoading = true
          await this.batUpdate({
            factoryStaffNutritionRawList,
          })
          await this.getList({...this.currentPage})
        }else{
          await this.getList({...this.currentPage})
        }
      }
    },

    async calculate(){
      const {rawId} = this.rawSelect
       const calculateResult = await this.fetchPost({
        actions:this.rawEquationCalculateBackGround,
        loading:'calculateLoading',
        showMessage:false,
        data:{
          equationId:this.equationId,
          factoryId:window.localStorage.getItem('factoryId'),
          nutritionValues:[   {
            "code": "",
            "convertUnit": "",
            "convertUnitId": 0,
            "createTime": "",
            "createUser": 0,
            "culationValue": 0,
            "fullName": "",
            "id": 0,
            "isCal": "",
            "isContain": "",
            "isDeleted": 0,
            "name": "",
            "nutritionId": 0,
            "nutritionValue": 0,
            "rawId": 0,
            "status": 0,
            "typeCode": "",
            "typeName": "",
            "unit": "",
            "unitId": 0,
            "updateTime": "",
            "updateUser": 0
          }],
          rawId,
        }
      })
      let {errorMsg,code} = calculateResult
      if(code === 400){
        console.log(errorMsg)
        this.$message.warning('指标数值异常，请修改后再计算。')
      }else{
        this.calculateResult = calculateResult
        this.setState({rawResult:calculateResult})
        this.toggleVisible('result')
      }
    },

    batList(res){
      let list = [...this.list.records]
      res.forEach((item)=>{
        const index = list.findIndex(i=>i.id === item.id)
        list.splice(index,1,{...item,editable:false})
      })
      this.list.records = list
    },

    async batUpdate(arg = {}){
      const res = await this.fetchPost({
        actions:this.batchUpdateStaffNutritionRawList,
        data:{
          factoryStaffNutritionRawList: this.list.records.map(i=>{
            const { isContain,factoryId,nutritionId,nutritionValue,	isBelongRaw,formulaId,rawId,id,staffId } = i
            return { isContain,factoryId,nutritionId,nutritionValue,	isBelongRaw,formulaId,rawId,id ,staffId}
          }),
          ...arg
        }
      })
      this.$emit("getRes")
      return res
    },
    async batUpdate2(arg = {}){
      const res = await this.fetchPost({
        actions:this.singleAutoUpdateStaffNutritionRawList,
        data:{
          factoryStaffNutritionRawList: this.list.records.map(i=>{
            const { isContain,factoryId,nutritionId,nutritionValue,	isBelongRaw,formulaId,rawId,id,staffId } = i
            return { isContain,factoryId,nutritionId,nutritionValue,	isBelongRaw,formulaId,rawId,id ,staffId}
          }),
          ...arg
        }
      })
      
      if(res){
        for(let item in res){
          let obj = this.list.records.find(el => el.code === item) || {}
          let newObj = res[item]
          if(obj && obj.code){
            obj.nutritionValue = newObj.nutritionValue
            obj.nutritionAnalysisVal = newObj.nutritionValue || newObj.nutritionValue === 0 ? newObj.nutritionValue : obj.baseNutritionVal
            obj.id = newObj.id
          }
        }
      }
      this.$emit("getRes")
      // this.getList()
      return res
    },

    itemChange(val, column) {
      const {nutritionId} = val
      let newData = [...this.list.records]
      let target = newData.filter(item => nutritionId === item.nutritionId)[0]
      // let dm = newData.filter(i=>i.name === 'DM')[0]
      // let moisture = newData.filter(i=>i.name === 'Moisture')[0]

      if (target) {
        let value = val[column]
        const isNull = value === '' || value === null
        const baseVal = target['baseNutritionVal'] === '' || target['baseNutritionVal'] === null ? null : target['baseNutritionVal']
        target['nutritionAnalysisVal'] = isNull ?  baseVal  : value
        target[column] = value
        // if(target.name === 'DM') {
        //   moisture.nutritionValue = isNull ? null : 100 - value
        //   moisture.nutritionAnalysisVal = isNull ? moisture.baseNutritionVal : 100 - value
        //   moisture.isChange = true
        // }
        // if(target.name === 'Moisture') {
        //   dm.nutritionValue = isNull ?  null : 100 - value
        //   dm.nutritionAnalysisVal = isNull ? dm.baseNutritionVal : 100 - value
        //   dm.isChange = true
        // }
        this.list.records = newData
      }
    },

    editorItem(id){
      const newData = [...this.list.records]
      const target = newData.filter(item => id === item.nutritionId)[0]
      this.editingKey = id
      if (target) {
        target.editable = true
        this.list.records = newData
      }
    },

    saveHandle(key){
      const newData = [...this.list.records]
      const newCacheData = [...this.cacheData]
      const target = newData.filter(item => key === item.nutritionId)[0]
      const targetCache = newCacheData.filter(item => key === item.nutritionId)[0]

      const dm = newData.filter(i=>i.name === 'DM')[0]
      const moisture = newData.filter(i=>i.name === 'Moisture')[0]

      if (target && targetCache) {
        delete target.editable
        this.list.records = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
        let factoryStaffNutritionRawList = [target]
        if(target.name === 'DM') factoryStaffNutritionRawList.push({...moisture,nutritionValue:100 - target.nutritionValue})
        if(target.name === 'Moisture') factoryStaffNutritionRawList.push({...dm,nutritionValue:100 - target.nutritionValue})
        
        this.batUpdate({
          factoryStaffNutritionRawList:factoryStaffNutritionRawList.map( item =>{
            const { isContain,factoryId,nutritionId,nutritionValue,	isBelongRaw,formulaId,rawId,id,staffId } = item
            return { isContain,factoryId,nutritionId,nutritionValue,	isBelongRaw,formulaId,rawId,id,staffId }
          })
        })
      }
    },
    update(target,key){
      const newData = [...this.list.records]
      const newCacheData = [...this.cacheData]
      // const targets = newData.filter(item => key === item.nutritionId)[0]
      const targetCache = newCacheData.filter(item => key === item.nutritionId)[0]

      // const dm = newData.filter(i=>i.name === 'DM')[0]
      // const moisture = newData.filter(i=>i.name === 'Moisture')[0]

      if (target && targetCache) {
        delete target.editable
        this.list.records = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
        let factoryStaffNutritionRawList = [target]
        // const value = target.nutritionValue
        // if(target.name === 'DM') factoryStaffNutritionRawList.push({...moisture, nutritionValue:value ? 100 - value : null,})
        // if(target.name === 'Moisture') factoryStaffNutritionRawList.push({...dm, nutritionValue:value ? 100 - value : null,})
        // const value = target.nutritionValue
        // if(target.name === 'DM') {
        //   factoryStaffNutritionRawList.push({...moisture, nutritionValue:value || value === 0 ? 100 - value : null,})
        //   moisture.nutritionValue = value || value === 0 ? 100 - value : null
        // }
        // if(target.name === 'Moisture') {
        //   factoryStaffNutritionRawList.push({...dm, nutritionValue:value || value === 0 ? 100 - value : null,})
        //   dm.nutritionValue = value || value === 0 ? 100 - value : null
        // }
        // return this.batUpdate({
        return this.batUpdate2({
          factoryStaffNutritionRawList:factoryStaffNutritionRawList.map( item =>{
            const { isContain,factoryId,nutritionId,nutritionValue,	isBelongRaw,formulaId,rawId,id ,staffId} = item
            return { isContain,factoryId,nutritionId,nutritionValue,	isBelongRaw,formulaId,rawId,id,staffId }
          })
        })
      }
    },

    searchChange(){
      this.list.records = JSON.parse(JSON.stringify([...this.cacheData]))
    },

    onSearch(){
      let arr = [...this.cacheData]
      let key = this.keyword.toLocaleLowerCase()
      if(this.keyword !== '') {
        this.list.records = arr.filter(i => i.name.toLocaleLowerCase().indexOf(key)!= -1 || i.code.toLocaleLowerCase().indexOf(key)!= -1)
      }else{
        this.list.records = arr
      }
      this.toggleContain(this.isContain,this.list.records)
    },

    typeChange(val){
      this.types = val
      this.filterData.typeId = [...val].pop()
      this.$nextTick(()=>{
        this.getList()
      })
    },
    nutritionChange(){
      this.getList()
    },

    async getEquationList(){
      const {data} = await this.fetchGet({
        actions:this.equationList,
        name:'equation',
        data:{
          size:200
        }
      })
      data && data.length && this.selectEquation(data[0].id)
    },

    async getList(arg= {}){
      // this.list.records = []
      if(this.rawSelect){
        const params = {
            rawId:this.rawSelect.rawId,
            factoryId:this.factoryId,
            formulaId:this.formulaId
          }
        if(this.types.length) params.typeId=[...this.types].pop()
        if(this.keyword) params.keyword = this.keyword
        const res = await this.fetchGet({
          actions:this.selectFactoryStaffNutritionRawMoistureVolatilizePage,
          // actions:this.nNutritionRawInfoPage,
          isList:true,
          loading:'listLoading',
          name:'list',
          data:{
            ...params,
            ...this.filterData,
            ...arg,
            size:1000
          }
        })
        let {data} = res || {}
        let {records} = data || {}
        this.cacheData = JSON.parse(JSON.stringify(records || []))
        this.$nextTick(()=>{
          this.toggleContain(this.isContain,this.list.records)
        })
        return res
      }
    },

    listChange(page){
      this.getList({...this.tablePageChange(page),...this.filterData})
    },
    
    ok(){
      // this.toggleVisible('raw')
      // this.resetRaw()
    },
    
    cancel(){
      this.toggleVisible('raw')
      // this.setState({rawSelect:null})
      this.resetRaw()
    },

    resetRaw(){
      this.keyword = ''
      this.types = []
      this.list.records = [...this.cacheData]
      this.filterData ={}
      this.cleanSelect()
    },
  }
}
</script>
<style lang="scss" scoped>
  .header{
    padding:0 0 15px;
  }
</style>
